import { render, staticRenderFns } from "./PeopleInActivity.vue?vue&type=template&id=43b06487"
import script from "./PeopleInActivity.vue?vue&type=script&lang=js"
export * from "./PeopleInActivity.vue?vue&type=script&lang=js"
import style0 from "./PeopleInActivity.vue?vue&type=style&index=0&id=43b06487&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports